import React, { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import Form from "../../../Helpers/Form/Form";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import trans from "../../../../utils";

import RolesBody from "./RolesBody";

export default function RolesForms({ onSuccess }) {
	const { form, isEditing } = useContext(popupcontext);

	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={isEditing ? trans("Edit role") : trans("Add new role")}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<Offcanvas.Body>
					<RolesBody />
				</Offcanvas.Body>
			</Form>
		</>
	);
}
